export const RESET = 'EXCMDAILYPLANITEM_UPDATE_RESET'
export const SET_ERROR = 'EXCMDAILYPLANITEM_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMDAILYPLANITEM_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMDAILYPLANITEM_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMDAILYPLANITEM_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMDAILYPLANITEM_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMDAILYPLANITEM_UPDATE_UPDATE_RETRIEVED'
